import React from 'react';
import { FieldDirection } from '@common/types/hilbi-form';

export interface HilbiFormCtx {
  direction: FieldDirection;
  variation: 'lined';
}

const formCtxInitialValue: HilbiFormCtx = {
  direction: 'horizontal',
  variation: 'lined',
};

export const FormCtx = React.createContext(formCtxInitialValue);
